import { Link } from "react-router-dom";
import { ArrowRight, MapPin } from "lucide-react";

/**
 * Soft, non-intrusive CTA card for inserting mid-article. Catches readers at
 * peak engagement (mid-scroll) — typically the highest-converting placement.
 */
export default function InlineQuizCard() {
  return (
    <aside
      className="my-12 rounded-3xl bg-[#2C4C3B] text-white p-6 md:p-8 relative overflow-hidden"
      data-testid="inline-quiz-card"
    >
      <div className="absolute -top-10 -right-10 w-48 h-48 bg-[#9CAF88]/15 rounded-full blur-3xl pointer-events-none" />
      <div className="relative flex flex-col md:flex-row md:items-center gap-5 md:gap-6">
        <div className="w-12 h-12 rounded-2xl bg-[#9CAF88]/25 flex items-center justify-center shrink-0">
          <MapPin className="w-5 h-5 text-[#F7F5F0]" />
        </div>
        <div className="flex-1">
          <div className="text-[11px] font-semibold uppercase tracking-wider text-[#9CAF88] mb-1.5">
            Free, no pressure
          </div>
          <h3 className="font-display text-xl md:text-2xl font-semibold leading-snug">
            Not sure which level of care your loved one needs?
          </h3>
          <p className="mt-2 text-[#F7F5F0]/80 text-sm md:text-base leading-relaxed max-w-xl">
            Take our 3-minute quiz. We&apos;ll match you with a vetted local advisor who knows your zip code — no spam, no obligation.
          </p>
        </div>
        <Link to="/quiz" className="shrink-0" data-testid="inline-quiz-card-cta">
          <span className="inline-flex items-center gap-2 bg-[#E07A5F] hover:bg-[#C96B52] text-white rounded-xl h-12 px-6 text-sm font-medium whitespace-nowrap transition">
            Find care <ArrowRight className="w-4 h-4" />
          </span>
        </Link>
      </div>
    </aside>
  );
}
